import React, { lazy } from 'react'
import { ViewLogin, ViewSignup } from '@/routes/preloadableModals'
const MagicOAuthCallback = lazy(() => import('@/pages/login/MagicOAuthCallback'))

import { brazilianCampainUrl, emailUpdateUrl, kycUrl, passwordUpdateUrl, recoverPassword } from '@/urls'
// Tiny constants-only module — does NOT pull in the heavy ViewSignup chunk
// (wagmi / @reown / @lifi). The signup view itself stays lazy below.
import { ViewSignupPages } from '@/pages/signup/ViewSignupPages'

const LoginReset = lazy(() => import('@/pages/login-reset'))
const ViewPasswordUpdate = lazy(() => import('@/pages/portfolio/components/password-update'))
const ViewEmailUpdate = lazy(() => import('@/pages/portfolio/components/email-update')) 
const Logout = lazy(() => import('@/pages/logout'))
const ViewRecoverPassword = lazy(() => import('@/pages/recover-password/ViewRecoverPassword'))
const ViewKYC = lazy(() => import('@/pages/kyc/ViewKYC'))
const ViewBrazilianCampain = lazy(() => import('@/pages/brazilian-campain'))
import {
  loginUrl,
  signupFormUrl, 
  loginRegisterUrl,
  loginResetUrl,
  emailConfirmationRequiredUrl,
  emailConfirmedUrl,
  setUserNameAfterSignIn,
  logoutUrl,
} from '@/urls'
import { Navigate } from 'react-router-dom'

export default [
  { path: '/l', element: <Navigate to={loginUrl()} replace /> },
  { path: '/callback', element: <MagicOAuthCallback /> },
  { path: signupFormUrl(), element: <ViewSignup startPage={ViewSignupPages.register} />, isModal: true },
  { path: logoutUrl(), element: <Logout /> },
  {
    path: emailConfirmationRequiredUrl(),
    element: <ViewSignup startPage={ViewSignupPages.email_confirmation_pending} />,
    isModal: true,
  },
  { path: setUserNameAfterSignIn(), element: <ViewSignup startPage={ViewSignupPages.set_username} />, isModal: true },
  { path: emailConfirmedUrl(), element: <ViewSignup startPage={ViewSignupPages.email_confirmed} />, isModal: true },
  { path: loginUrl(), element: <ViewLogin />, isModal: true },
  { path: loginRegisterUrl(), element: <ViewLogin />, isModal: true },
  { path: passwordUpdateUrl(), element: <ViewPasswordUpdate /> },
  { path: emailUpdateUrl(), element: <ViewEmailUpdate /> },
  { path: loginResetUrl(), element: <LoginReset />, isModal: true },
  { path: recoverPassword(), element: <ViewRecoverPassword />, isModal: true },
  { path: kycUrl(), element: <ViewKYC />, isModal: true },
  { path: brazilianCampainUrl(), element: <ViewBrazilianCampain /> },
]
